import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import faqCategoryApi from '@infrastructure/faq-category-api';
export const getFaqCategoriesByEventIdAsync = createAsyncThunk('faqCategory/getByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.getFaqCategoriesByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFaqsByEventIdForRegistrationAsync = createAsyncThunk('faqCategory/getByEventIdForRegistration', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.getFaqsByEventIdForRegistration(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFaqCategoryByIdAsync = createAsyncThunk('faqCategory/getById', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.getFaqCategoryById(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createFaqCategoryAsync = createAsyncThunk('faqCategory/create', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.createFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFaqCategoryAsync = createAsyncThunk('faqCategory/update', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.updateFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFaqCategoryAsync = createAsyncThunk('faqCategory/delete', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.deleteFaqCategory(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reorderFaqCategoriesAsync = createAsyncThunk('faqCategory/reorder', async (request, { rejectWithValue }) => {
    try {
        const response = await faqCategoryApi.reorderFaqCategories(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
